import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import '../pages/AboutUs.css'
import aboutImg from '../assets/images/about.png'
import FramedImage from '../components/FramedImage'

function AboutUs() {
    return (
        <Container fluid className='aboutUsContainer' id='aboutUsContainer'>
            <Row className='align-items-center'>
                <Col md={6} className='mb-4 mb-md-0 order-2 order-md-1'>
                    <h2 className='aboutHeading'>About Us</h2>
                    <p className='aboutText'>
                        Welcome to Resolution Experts Alliance Association, a distinguished and innovative organization specializing in Alternative Dispute Resolution (ADR) and Online Dispute Resolution (ODR). With a rich history of excellence and a forward-looking approach, Resolution Experts Alliance Association has established itself as a leader in the field, dedicated to reshaping the landscape of conflict resolution. Our organization operates at the intersection of law, technology, and collaboration, offering clients a comprehensive suite of services that prioritize efficiency, cost-effectiveness, and sustainable solutions.
                    </p>
                </Col>

                <Col md={6} className='order-1 order-md-2'>
                    <FramedImage
                        src={aboutImg}
                        alt='About Resolution Experts Alliance Association'
                        imageClassName='aboutImage'
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default AboutUs
